import { Component, input } from '@angular/core';

@Component({
	selector: 'arrow-icon',
	templateUrl: './arrow-icon.html',
	standalone: true
})
export class ArrowIconComponent {
	color = input<string>('#F7AE1E');
	size = input<number>(12);
}

